"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStandardKette = exports.standardKetteUseableDef = void 0;
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const schemaVersions_1 = require("../schemaVersions");
const echain_shared_modelling_1 = require("@igus/echain-shared-modelling");
const KetteSerieType_1 = require("./KetteSerieType");
exports.standardKetteUseableDef = {
    parent: schemaVersions_1.ketteLatestUseableDef,
    validation: {
        KetteSerieType: (v) => v === KetteSerieType_1.KetteSerieType.default,
        Teilung: echain_shared_quantities_1.isQuantityJson,
        // Id: true, we cant validate the Id, since invented articles won't have one!
        Bezeichnung: true,
        Aussenhoehe: true,
        Biegeradius: true,
    },
};
exports.isStandardKette = echain_shared_modelling_1.UseableUtil.createGuard(exports.standardKetteUseableDef);
//# sourceMappingURL=StandardKette.js.map